module.exports = "<a ng-click=$ctrl.showContactForm($event) class=contact>{{ $ctrl.label }}</a> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/tsz-contact/tsz-contact.html
// module id = 132
// module chunks = 1